// extracted by mini-css-extract-plugin
export default {"loadingBanner":"_e748d35"};